
export const ticketsData = [
  {
    tier: 'General Access',
    price: 350,
    availability: 'Limited availability',
    featured: false,
    benefits: [
      'Access to all runway shows',
      'Designer showcase viewing',
      'Opening night reception',
      'Event program and materials',
      'General seating'
    ]
  },
  {
    tier: 'VIP',
    price: 850,
    availability: 'Selling fast',
    featured: true,
    benefits: [
      'Priority runway seating',
      'All general access benefits',
      'VIP lounge access',
      'Meet and greet with designers',
      'Exclusive after-parties',
      'Gift bag with designer items'
    ]
  },
  {
    tier: 'Front Row',
    price: 1500,
    availability: 'Very limited',
    featured: false,
    benefits: [
      'Front row runway seating',
      'All VIP benefits included',
      'Private designer consultations',
      'Backstage access pass',
      'Premium gift collection',
      'Concierge service'
    ]
  },
  {
    tier: 'All-Access',
    price: 2500,
    availability: 'Exclusive',
    featured: false,
    benefits: [
      'Complete festival access',
      'All front row benefits',
      'Private events and dinners',
      'One-on-one designer meetings',
      'Luxury transportation',
      'Personalized styling session',
      'Lifetime alumni status'
    ]
  }
];
